import {
  SearchIcon,
  MicrophoneIcon,
} from "@/ui/Icons";
import { UniversalSearchProps } from "./types";
import { useCmdK } from "../CommunicationView/CmdK/CmdK";
import { Sparkle } from "@phosphor-icons/react";

export const UniversalSearch: React.FC<UniversalSearchProps> = () => {
  const { open } = useCmdK();

  return (
    <form data-testid="UniversalSearch" className="md:flex items-center hidden">
      <label htmlFor="voice-search" className="sr-only">
        Search
      </label>
      <div className="relative w-full">
        <div className="absolute inset-y-0 left-0 flex items-center pl-[10px] pointer-events-none">
          <Sparkle className="text-black/50 dark:text-white/50" />
        </div>
        <input
          type="text"
          id="search"
          className="bg-black/5 dark:bg-white/10 border-0 text-black dark:text-white/40 text-sm rounded-lg block w-full py-2 focus:ring-0 focus:outline-0"
          style={{ paddingLeft: 36 }}
          placeholder="Ask Copilot..."
          // placeholder="Search or Ask AI..."
          onClick={(e) => e.preventDefault()}
          onKeyDown={open}
          onMouseDown={open}
          onFocus={(e) => e.target.blur()}
        />
        <span className="absolute inset-y-[2px] right-0 p-2 text-black/50 dark:text-white/30 text-xs">⌘K</span>
      </div>
    </form>
  );
};

export default UniversalSearch;
